export type Bonus = {
  number: string;
  title: string;
  price: string;
  body: string;
  image: string;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The 90-Second Studio Prep Card™',
    price: '$15',
    body: 'Walk into every class injury-ready before anyone says a word: the 30-second class scan, the 20-second pain conversation, and the Do / Don\'t / Document box. Printable + mobile version.',
    image: 'https://cdn.magicpatterns.com/uploads/rBMcwA29cbGR1KrbuJMjt9/screen-bono-1.webp',
  },
  {
    number: '02',
    title: 'The Injury Language Decoder™',
    price: '$10',
    body: '"My back is out." "My hip pinches." "My knee feels weird." Translate vague client language into clear teaching decisions — without guessing, diagnosing, or panicking.',
    image: 'https://cdn.magicpatterns.com/uploads/iK7x3Qas8XQ7epbNHzb1tn/screen-bono-2.webp',
  },
  {
    number: '03',
    title: 'The Safe Substitution Starter Pack™',
    price: '$8',
    body: 'Mat and reformer substitution charts plus the Reduce / Replace / Remove framework. Know exactly what to teach instead — in seconds, without losing the goal of the exercise.',
    image: 'https://cdn.magicpatterns.com/uploads/byVu97S621TdK96kW3MaJu/screen-bono-3.webp',
  },
  {
    number: '04',
    title: 'The Calm Confidence Script Bank™',
    price: '$13',
    body: 'Word-for-word scripts for 12 awkward studio moments: modifying without drama, holding boundaries with "pushers," and referring out without losing the client.',
    image: 'https://cdn.magicpatterns.com/uploads/pT3Js9sLX9okWe78xd4o49/screen-bono-4.webp',
  },
  {
    number: '05',
    title: 'The First 7 Days Implementation Map™',
    price: '$14',
    body: 'Ten minutes a day for seven days and the system is downloaded, bookmarked, personalized and rehearsed. The difference between "I bought a PDF" and "I run a studio system."',
    image: 'https://cdn.magicpatterns.com/uploads/vvWcX8EeYJJXjvZoCPTXSS/screen-bono-5.webp',
  },
];
